import { Breadcrumbs } from "components/UI/Breadcrumbs/Breadcrumbs.tsx";
import { FC, HTMLAttributes, PropsWithChildren } from "react";

interface ContentWrapperProps extends HTMLAttributes<HTMLDivElement> {
    wrapperClassName?: string;
}

export const ContentWrapper: FC<PropsWithChildren<ContentWrapperProps>> = ({
    children,
    wrapperClassName,
    ...props
}) => {
    return (
        <>
            <Breadcrumbs className={"my-4"} />
            <div className={`min-h-[360px] my-4 justify-center m-auto ${wrapperClassName ?? ""}`} {...props}>
                {children}
            </div>
        </>
    );
};
